// removed by extract-text-webpack-plugin
module.exports = {"navItem":"styles__navItem___2GkPL","flexWrap":"styles__flexWrap___2Ccxt","studio-wrapper":"styles__studio-wrapper___1Dn1A","nav":"styles__nav___2azc7","page-wrapper":"styles__page-wrapper___Iw6-h","item":"styles__item___QP0tF","name":"styles__name___NEWa_","position":"styles__position___1vufT","specifications":"styles__specifications___2tEW1","campusMapLink":"styles__campusMapLink___Y72MA"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Studios/styles.scss
// module id = 187
// module chunks = 0